import { reactive } from 'vue'
import { FilterStore } from './filter-store'

/**
 * Place to store mutable state pertaining to reviews.
 */

// toolbar including sort, search, and filters
export const MIN_REVIEWS_FOR_TOOLBAR = 3

/**
 * Interface for the state property inside the store
 */
export interface IReviewsStoreState {
  filterStore: FilterStore
  sort: string
  searchTerm: string
  trimmedSearchTerm: string
}

export class ReviewsStore {
  constructor() {
    this.state.filterStore = new FilterStore()
  }

  state: IReviewsStoreState = reactive({
    filterStore: undefined,
    sort: undefined,
    searchTerm: '',
    trimmedSearchTerm: ''
  })

  get filterStore(): FilterStore {
    return this.state.filterStore
  }

  set sort(sort: string) {
    this.state.sort = sort
  }

  get sort(): string {
    return this.state.sort
  }

  set searchTerm(searchTerm: string) {
    this.state.searchTerm = searchTerm
    this.state.trimmedSearchTerm = searchTerm.trim()
  }

  get searchTerm(): string {
    return this.state.searchTerm
  }

  get trimmedSearchTerm(): string {
    return this.state.trimmedSearchTerm
  }
}

export default new ReviewsStore()
